export default __webpack_public_path__ + "static/media/formkeep.a64a82a3.svg";